// import { Mode } from "@/pages/receiving/components/modal/common/const";
import { useState } from "react";
import { OcrCameraAggregateModeType, OcrCameraAggregateMode } from "@/shared/config/globals";

const usePhotoShootStates = () => {
  // 撮影写真リスト
  const [imageList, setImageList] = useState<string[]>([]);
  // 詳細画面に遷移する前の画面情報
  const [previousScreen, setPreviousScreen] = useState<OcrCameraAggregateModeType>(OcrCameraAggregateMode.Shoot);
  // 撮影枚数
  const [photoShootCount, setPhotoShootCount] = useState<number>(0);

  return {
    imageList,
    setImageList,
    previousScreen,
    setPreviousScreen,
    photoShootCount,
    setPhotoShootCount,
  };
};

export default usePhotoShootStates;
